import {getMessages} from 'app/store/constants';

export const COPY_TEXT = getMessages().getText('board_settings.actions.copy.text');
export const COPY_TEXT_LINK = getMessages().getText('board_settings.actions.copy.text.link');
export const COPY_BUTTON = getMessages().getText('board_settings.actions.copy');

export const COPY_LINK = 'https://www.kanbanchi.com/faqwd/copy-dashboard';
